import { MealTime } from "@/clients/models/MealTime";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { useIonRouter } from "@ionic/react";
import { useParams } from "react-router-dom";
import MealCreatingProgress from "../../components/meal-creating-progress";
import { useCheckCandidateCreation } from "../../hooks/use-check-candidate-creation";

export default function FavouriteFoodCandidatesCreating() {
  const navigation = useIonRouter();
  const { mealTime } = useParams<{ mealTime: MealTime }>();
  useCheckCandidateCreation({
    mealTime,
    onCompleted: () => {
      navigation.push(
        `/profiling/favourites/add-plan/${mealTime}`,
        "forward",
        "replace",
      );
    },
  });
  return (
    <ProfilePageContainer
      showToolbar={false}
      className="h-full flex flex-col items-center justify-center"
    >
      <MealCreatingProgress />
    </ProfilePageContainer>
  );
}
